// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Api
import { allValuesLanguage, Language, translateLanguage } from "@startapp/mistral-admin-api";

// MARK: Mobx
import { inject, observer } from "mobx-react";

// MARK: Components
import { AppBar, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Toolbar, Typography } from "@material-ui/core";

// MARK: Icons
import {
	Build as BuildIcon,
	ChevronLeft as ChevronLeftIcon,
	ExitToApp as ExitToAppIcon,
	Home as HomeIcon,
	Hotel as HotelIcon,
	LocalOffer as LocalOfferIcon,
	MeetingRoom as MeetingRoomIcon,
	Menu as MenuIcon,
	PermMedia as PermMediaIcon,
	PhotoLibrary as PhotoLibraryIcon,
	Restaurant as RestaurantIcon,
	StarRate as StarRateIcon,
} from "@material-ui/icons";

// MARK: Components
import SelectOptions from "../../../components/SelectOptions";

// MARK: Resources
import strings from "../../../resources/strings";

// MARK: Stores
import { languageStore, routerStore } from "../../../stores/_rootStore";
import AuthStore from "../../../stores/AuthStore";

interface IStores {
	authStore: AuthStore;
}

interface IProps extends IStores {
	hiddenMenu?: boolean;
	hiddenLanguageSelector?: boolean;
}

interface IState {
	open: boolean;
}

@inject("authStore")
@observer
export default class Navbar extends React.Component<IProps, IState> {
	public state = {
		open: false,
	};

	public static defaultProps: IStores;

	private handleDrawerOpen = () => this.setState({ open: true });

	private handleDrawerClose = () => this.setState({ open: false });

	public onItemClick = (route: string) => {
		routerStore.push(route);
		this.handleDrawerClose();
	};

	public render() {
		const { hiddenMenu, hiddenLanguageSelector } = this.props;
		return (
			<>
				<AppBar position="fixed">
					<Toolbar className="toolbar">
						{!hiddenMenu && (
							<IconButton className="menuIcon" aria-label="Menu" onClick={this.handleDrawerOpen}>
								<MenuIcon />
							</IconButton>
						)
						}
						<Typography className="title" variant="h5">{strings.nav.title}</Typography>

					</Toolbar>
				</AppBar>
				{!hiddenLanguageSelector && (
					<div className="languageSelector">
						<SelectOptions
							title={strings.languages.title}
							values={allValuesLanguage().filter((lang) => lang !== Language.esEs)}
							translatorValue={translateLanguage}
							changeValue={languageStore.changeLanguage}
							selectedValue={languageStore.selectedLanguage}
						/>
					</div>
				)
				}
				<div className="navbarPlaceholder" />
				<Drawer
					variant="persistent"
					anchor="left"
					className="sidedrawer"
					open={this.state.open}
				>
					<div className="closeButtonContainer">
						<IconButton onClick={this.handleDrawerClose}><ChevronLeftIcon /></IconButton>
					</div>
					<List>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/")}
						>
							<ListItemIcon><HomeIcon /></ListItemIcon>
							<ListItemText primary={strings.nav.home} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/banners")}
						>
							<ListItemIcon><PermMediaIcon /></ListItemIcon>
							<ListItemText primary={strings.banner.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/offers")}
						>
							<ListItemIcon><LocalOfferIcon /></ListItemIcon>
							<ListItemText primary={strings.offers.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/gastroPlaces")}
						>
							<ListItemIcon><RestaurantIcon /></ListItemIcon>
							<ListItemText primary={strings.gastroPlaces.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/rooms")}
						>
							<ListItemIcon><MeetingRoomIcon /></ListItemIcon>
							<ListItemText primary={strings.rooms.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/bedrooms")}
						>
							<ListItemIcon><HotelIcon /></ListItemIcon>
							<ListItemText primary={strings.bedrooms.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/gallery")}
						>
							<ListItemIcon><PhotoLibraryIcon /></ListItemIcon>
							<ListItemText primary={strings.gallery.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/edithotel")}
						>
							<ListItemIcon><BuildIcon /></ListItemIcon>
							<ListItemText primary={strings.hotel.edit.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={() => this.onItemClick("/dashboard/surveys")}
						>
							<ListItemIcon><StarRateIcon /></ListItemIcon>
							<ListItemText primary={strings.surveys.title} />
						</ListItem>
						<ListItem
							button={true}
							onClick={this.props.authStore.logout}
						>
							<ListItemIcon><ExitToAppIcon /></ListItemIcon>
							<ListItemText primary={strings.nav.logout} />
						</ListItem>
					</List>
				</Drawer>
			</>
		);
	}
}
